import React from 'react';
import pageAssets from '../../../../data/pageAssets';
import AppImage from '../../../common/media/AppImage';
import { openQuoteChat } from '../../../../utils/site';

const OrbitStarHeroSection = ({ hero, onBuy }) => (
    <section id="orbit-star-hero" className="orbit-star-hero">
        <div className="container">
            <div className="orbit-star-hero-grid">
                <div className="orbit-star-hero-content">
                    <div className="orbit-star-hero-badge">{hero.badge}</div>
                    <h1 className="orbit-star-hero-title">
                        {hero.titleLine1} <span>{hero.titleLine2}</span>
                    </h1>
                    <p className="orbit-star-hero-subtitle">{hero.subtitle}</p>
                    <p className="orbit-star-hero-description">{hero.description}</p>
                    <div className="orbit-star-hero-actions">
                        <button type="button" className="btn btn-primary btn-lg" onClick={onBuy}>
                            {hero.primaryCtaLabel}
                        </button>
                        <button type="button" className="btn btn-lg orbit-star-hero-btn-ghost" onClick={openQuoteChat}>
                            {hero.secondaryCtaLabel}
                        </button>
                    </div>
                </div>
                <div className="orbit-star-hero-image">
                    <AppImage src={pageAssets[hero.imageKey]} alt={hero.imageAlt} priority width="560" height="560" />
                </div>
            </div>
            <ul className="orbit-star-trust-strip">
                {hero.trustStrip.map((item) => <li key={item}>{item}</li>)}
            </ul>
        </div>
    </section>
);

export default OrbitStarHeroSection;
